import React from "react";

export const About = () => {
  return (
    <div className="aboutPage" id="#about">
      <h5>MORE OF MY WORKS —</h5>
      <h2>Skills I have acquired ☄️</h2>
      <div className="aboutContent">
        <div className="skills">
          <img src="ReactIcon.svg" alt="React Icon"></img>
          <h5>React</h5>
        </div>
        <div className="skills">
          <img src="PostmanIcon.svg" alt="Postman Icon"></img>
          <h5>Postman</h5>
        </div>
        <div className="skills">
          <img src="JavaScriptIcon.svg" alt="JavaScript Icon"></img>
          <h5>JavaScript</h5>
        </div>
        <div className="skills">
          <img src="PythonIcon.svg" alt="Python Icon"></img>
          <h5>Python</h5>
        </div>
        <div className="skills">
          <img src="Database.svg" alt="MySQL Icon"></img>
          <h5>MySQL</h5>
        </div>
        <div className="skills">
          <img src="NodeIcon.svg" alt="Node Icon"></img>
          <h5>Node</h5>
        </div>
        <div className="skills">
          <img src="Database.svg" alt="MongoDB Icon"></img>
          <h5>MongoDB</h5>
        </div>
        <div className="skills">
          <img src="ExpressIcon.svg" alt="Express Icon"></img>
          <h5>Express</h5>
        </div>
        <div className="skills">
          <img src="FigmaIcon.svg" alt="Figma Icon"></img>
          <h5>Figma</h5>
        </div>
      </div>
    </div>
  );
};
